import {useGlobalState} from "app/user/GlobalStateProvider";
import {Button, Card, Form, Input} from "antd";
import {Link, useNavigate, useSearchParams} from "react-router";
import {linkLogin} from "app/nav/links";
import {RETURN_TO_PARAM} from "app/util/constants";
import {useEffect} from "react";

interface IRegisterForm {
  email: string;
  password: string;
  passwordRepeat: string;
}

export const RegisterForm = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const {isLoggedIn, registerUser} = useGlobalState();

  const onFinish = async (values: IRegisterForm) => {
    const {email, password, passwordRepeat} = values;
    if (password !== passwordRepeat) {
      // Handle password mismatch error
      console.error("Passwords do not match");
      return;
    }
    await registerUser({variables: {input: {email, password, passwordRepeat}}});
  };

  useEffect(() => {
    if (isLoggedIn) {
      const returnTo = searchParams.get(RETURN_TO_PARAM) || "/";
      navigate(returnTo);
    }
  }, [isLoggedIn, navigate, searchParams]);

  return (
    <div className="flex justify-center">
      <Card className="shadow-md w-md" title="Register">
        <Form<IRegisterForm> layout="vertical" onFinish={onFinish}>
          <Form.Item<IRegisterForm>
            label="Email"
            name="email"
            rules={[
              {required: true, message: "Please input your email!"},
              {type: "email", message: "Please enter a valid email!"}
            ]}
          >
            <Input autoComplete="username" placeholder="Enter your email" />
          </Form.Item>

          <Form.Item<IRegisterForm>
            label="Password"
            name="password"
            rules={[
              {required: true, message: "Please input your password!"},
              {min: 4, message: "Password must be at least 4 characters!"}
            ]}
          >
            <Input.Password autoComplete="new-password" placeholder="Enter your password" />
          </Form.Item>

          <Form.Item<IRegisterForm>
            dependencies={["password"]}
            label="Repeat Password"
            name="passwordRepeat"
            rules={[
              {required: true, message: "Please confirm your password!"},
              ({getFieldValue}) => ({
                validator(_, value) {
                  if (!value || getFieldValue("password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("The two passwords do not match!"));
                }
              })
            ]}
          >
            <Input.Password autoComplete="new-password" placeholder="Repeat your password" />
          </Form.Item>

          <Form.Item>
            <div className="flex gap-3 items-center">
              <Button htmlType="submit" type="primary">
                Register
              </Button>
              <div>
                Already have an account? <Link to={linkLogin()}>Login</Link>
              </div>
            </div>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
